'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isPlainObject = require('./isPlainObject.js');
function isJSONValue(value) {
    switch(typeof value === "undefined" ? "undefined" : _type_of(value)){
        case 'object':
            {
                return value === null || isJSONArray(value) || isJSONObject(value);
            }
        case 'string':
        case 'number':
        case 'boolean':
            {
                return true;
            }
        default:
            {
                return false;
            }
    }
}
function isJSONArray(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    return value.every(function(item) {
        return isJSONValue(item);
    });
}
function isJSONObject(obj) {
    if (!isPlainObject.isPlainObject(obj)) {
        return false;
    }
    var keys = Reflect.ownKeys(obj);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var value = obj[key];
        if (typeof key !== 'string') {
            return false;
        }
        if (!isJSONValue(value)) {
            return false;
        }
    }
    return true;
}
exports.isJSONArray = isJSONArray;
exports.isJSONObject = isJSONObject;
exports.isJSONValue = isJSONValue;
